import { ModelSetTransformer, ModelTransformer } from '../common/common.model';

export interface ExtTeamManagementEffectivenessItem {
    userID: number;
    userName: string;
    cao: number;
    opportunityAlignment: number;
    cpc: number;
    mI2: number;
}

export interface TeamManagementEffectivenessItem {
    userId: number;
    username: string;
    cao: number;
    opportunityAlignment: number;
    cpc: number;
    mi2: number;
}

export interface TeamManagementEffectiveness {
    overall: TeamManagementEffectivenessItem;
    items: TeamManagementEffectivenessItem[];
}

class TeamManagementEffectivenessItemModelTransformer
    implements
        ModelTransformer<
            TeamManagementEffectivenessItem,
            ExtTeamManagementEffectivenessItem
        >
{
    transform(
        model: ExtTeamManagementEffectivenessItem,
    ): TeamManagementEffectivenessItem {
        return {
            userId: model.userID,
            username: model.userName,
            cao: model.cao,
            opportunityAlignment: Math.min(1, model.opportunityAlignment),
            cpc: model.cpc,
            mi2: model.mI2,
        };
    }
}

class TeamManagementEffectivenessItemModelSetTransformer extends ModelSetTransformer<
    TeamManagementEffectivenessItem,
    ExtTeamManagementEffectivenessItem
> {
    protected newTransformer(): ModelTransformer<
        TeamManagementEffectivenessItem,
        ExtTeamManagementEffectivenessItem
    > {
        return new TeamManagementEffectivenessItemModelTransformer();
    }
}

export class TeamManagementEffectivenessModelTransformer
    implements
        ModelTransformer<
            TeamManagementEffectiveness,
            ExtTeamManagementEffectivenessItem[]
        >
{
    transform(
        model: ExtTeamManagementEffectivenessItem[],
    ): TeamManagementEffectiveness {
        const overall_ = model.filter((value) => value.userID <= 0);
        let overall;
        if (overall_.length) {
            overall =
                new TeamManagementEffectivenessItemModelTransformer().transform(
                    overall_[0],
                );
        }

        const items_ = model.filter((value) => value.userID > 0);
        const items =
            new TeamManagementEffectivenessItemModelSetTransformer().transform(
                items_,
            );

        return {
            overall,
            items,
        };
    }
}

export function validateTeamManagementEffectiveness(
    model: TeamManagementEffectiveness,
): void {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    const valid =
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        model != null &&
        model.overall != null &&
        model.items != null &&
        model.items.length !== 0;
    if (!valid) {
        throw new Error('TeamManagementEffectiveness not valid');
    }
}
